// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3P19i","cell":"ColumnAccessor_cell__1gNGp","firstCellAccent":"ColumnAccessor_firstCellAccent__1_jK6"};